import axios from 'axios';
import { envs } from '../utils/env';
import { initAxiosInterceptor } from './axios';
const { umsBaseUrl, hmsBaseUrl } = envs;

export const apiUms = axios.create({
	baseURL: umsBaseUrl,
	withCredentials: true
});

export const apiHms = axios.create({
	baseURL: hmsBaseUrl,
	withCredentials: true
});

/**
 * adds appType request header in requests
 */
initAxiosInterceptor([apiUms, apiHms]);
